import Vue from 'vue';
import { ActionTree } from 'vuex';
import { PipelineState } from './state';
import RootState from '@/store/root_state';
import pipeline from '@/pipeline';
import router from '@/router';
import { MicroserviceEnum, mutation, query } from '@/helpers/westeros';
import {
  getPipelineRun,
  GetPipelineRunQueryResult,
} from '@/store/graphql/queries/westerosArcaneumQueries';
import {
  upsertPipelineRun,
  UpsertPipelineRunMutationResult,
} from '@/store/graphql/mutations/westerosArcaneumMutations';
import { Context } from '@/pipeline/stateMachine';
import { State } from 'xstate';

const actions: ActionTree<PipelineState, RootState> = {
  async START_PIPELINE({ commit, state, rootState }): Promise<void> {
    pipeline.start(router, state.currentState);

    pipeline.addTransitionListener(async (currentState: State<Context>) => {
      try {
        const variables = { enrollmentId: rootState.enrollment.enrollmentId, state: currentState };
        const { data } = await mutation<UpsertPipelineRunMutationResult>(
          MicroserviceEnum.ARCANEUM,
          upsertPipelineRun,
          variables,
        ).catch(() => ({ data: null }));

        if (data?.upsertPipelineRun) {
          const pipeline: PipelineState = {
            id: data?.upsertPipelineRun.id,
            currentState: data?.upsertPipelineRun.state,
          };

          commit('SET_PIPELINE', pipeline);
        }
      } catch {
        // suppress error
      }
    }, true);
  },

  async PULL_PIPELINE({ commit, rootState }): Promise<void> {
    const authToken = Vue.$cookies.get('admissions-auth-token');
    const isAuthenticated = Boolean(authToken);

    if (!isAuthenticated) throw new Error('Forbidden');

    const variables = { enrollmentId: rootState.enrollment.enrollmentId };

    const { data } = await query<GetPipelineRunQueryResult>(
      MicroserviceEnum.ARCANEUM,
      getPipelineRun,
      variables,
    ).catch(() => ({ data: null }));

    if (data?.getPipelineRun) {
      const pipeline: PipelineState = {
        id: data?.getPipelineRun.id,
        currentState: data?.getPipelineRun.state,
      };

      commit('SET_PIPELINE', pipeline);
    }
  },
};

export default actions;
